import { render, staticRenderFns } from "./DetalleRecepcionModal.vue?vue&type=template&id=0d75222d"
import script from "./DetalleRecepcionModal.vue?vue&type=script&lang=js"
export * from "./DetalleRecepcionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports